export default "__VITE_ASSET__D05DQocM__"